var chunkToChildrenMap = {
	"347": [
		4196
	],
	"1649": [
		4106
	],
	"4106": [
		4196
	],
	"4196": [
		4106
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));